import { WidgetAutocheck, WidgetFees } from "@redotech/redo-model/widget";
import {
  ExtensionShopifyClient,
  ShopifyProductJS,
  ShopifyProducts,
} from "@redotech/shopify-client/ajax";

import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
} from "@redotech/redo-web/utils/local-storage-wrapper";
import { CommercecloudStorefrontClient } from "../client/commercecloud-storefront";

const REDO_PRODUCTS_CACHE_KEY = "redo_products";

async function getRedoProducts({
  autocheck,
  fees,
  storefrontClient,
}: {
  autocheck: WidgetAutocheck;
  fees: WidgetFees;
  storefrontClient: ExtensionShopifyClient;
}) {
  let shopifyProducts: ShopifyProducts = {};
  if (autocheck.paidModel !== "merchant_paid") {
    if (
      autocheck.packageProtection.splitProducts &&
      fees.returnProduct?.handle &&
      fees.packageProduct?.handle &&
      fees.bothProduct?.handle
    ) {
      const promises = [
        storefrontClient.productGetJS(fees.returnProduct.handle),
        storefrontClient.productGetJS(fees.packageProduct.handle),
        storefrontClient.productGetJS(fees.bothProduct.handle),
      ];

      const products: (ShopifyProductJS | undefined)[] =
        await Promise.all(promises);

      for (const product of products) {
        if (!product) {
          continue;
        }
        product.variants.sort((a, b) => a.price - b.price);
      }

      const returnShopifyProduct = products[0];
      const packageShopifyProduct = products[1];
      const bothShopifyProduct = products[2];
      const mainShopifyProduct =
        bothShopifyProduct || returnShopifyProduct || packageShopifyProduct;

      shopifyProducts = {
        mainShopifyProduct,
        returnShopifyProduct,
        packageShopifyProduct,
        bothShopifyProduct,
      };
    } else if (globalThis.redoStorefront?.type === "commercecloud") {
      shopifyProducts = {
        mainShopifyProduct: CommercecloudStorefrontClient.getProductJsFromFees({
          fees,
        }),
      };
    } else {
      const product = await storefrontClient.productGetJS(fees.handle);
      product.variants.sort((a, b) => a.price - b.price);
      shopifyProducts = { mainShopifyProduct: product };
    }
  }

  setLocalStorageWithExpiry(REDO_PRODUCTS_CACHE_KEY, shopifyProducts, 0.1);
  return shopifyProducts;
}

export async function getRedoProductsCache({
  autocheck,
  fees,
  storefrontClient,
}: {
  autocheck: WidgetAutocheck;
  fees: WidgetFees;
  storefrontClient: ExtensionShopifyClient;
}) {
  const shopifyProducts = getLocalStorageWithExpiry(REDO_PRODUCTS_CACHE_KEY);
  if (shopifyProducts) {
    void getRedoProducts({ autocheck, fees, storefrontClient });
    return shopifyProducts;
  }

  return await getRedoProducts({ autocheck, fees, storefrontClient });
}
